
import { Base } from '../base-component';
import './podcast.component.scss';

import * as $ from 'jquery';

export class Podcast extends Base {

	scriptContainer: any;
	cloned: any;
	audio: any;
	button: any;
	current: any;
	duration: any;
	progress: any;
	progressDiv: any;
	volume: any;
	volumeButton: any;
	volumeDiv: any;
	volumeDivThumb: any;
	valueDuration: any;
	valueCurrentTime: any;
	valueStoredVolume: any;

	constructor(element: Element){

		super(element);

	}

	init(){

		if(this.element.clientWidth < 575) {

			this.element.classList.add('smaller')

		}

		this.scriptContainer = this.element.querySelector('.podcast__script');
		this.cloned = this.element.querySelector('audio');
		this.audio = this.element.querySelector('audio');
		this.button = this.element.querySelector('.js-play-button');
		this.current = Array.from(this.element.querySelectorAll('.js-time-played'));
		this.duration = Array.from(this.element.querySelectorAll('.js-time-total'));
		this.progress = this.element.querySelector('.js-range-progress');
		this.progressDiv = this.element.querySelector('.podcast__player--buffer__progress--filled');
		this.volume = this.element.querySelector('.js-range-volume');
		this.volumeButton = this.element.querySelector('.js-volume-button');
		this.volumeDiv = this.element.querySelector('.podcast__player--volume__progress--filled');
		this.volumeDivThumb = this.element.querySelector('.podcast__player--volume__progress--button');

		this.valueStoredVolume = 0.5;
		this.volume.value = 0.5;
		this.volumeDiv.style.width = 50 + "%";
		this.volumeDivThumb.style.left = 50 + "%";

		this.createCustomAudioPlayer();

	}

	bindEvents() {

		let ua = window.navigator.userAgent;
		let msie = ua.indexOf("MSIE ");

		if(this.button) {
			this.button.addEventListener('click', (event)=>{
				let element;
				if(event.currentTarget) {
					element = event.currentTarget;
				}else{
					element = event.target
				}
				if(element.classList.contains('playing')){
					element.classList.remove('playing');
					this.pauseAudio();
				}else{
					element.classList.add('playing');
					this.playAudio();
				}
			})
		}

		if(this.progress){

			if (msie > 0) {

				this.progress.addEventListener('change', (event)=>{
					this.changeProgress(event);
				})

			}else{

				this.progress.addEventListener('input', (event)=>{
					this.changeProgress(event);
				})

			}
		}

		if(this.volume){

			if (msie > 0) {

				this.volume.addEventListener('change', (event)=>{
					this.changeVolume(event);
				})

			}else{

				this.volume.addEventListener('input', (event)=>{
					this.changeVolume(event);
				})

			}
			
		}

		if(this.volumeButton) {
			this.volumeButton.addEventListener('click', (event)=>{
				this.muteClick(event);
			})
		}

	}

	playAudio() {
		if(this.audio) {
			this.audio.play();
		}
	}

	pauseAudio() {
		if(this.audio) {
			this.audio.pause();
		}
	}

	createCustomAudioPlayer() {

		if(this.cloned) {

			let source = Array.from(this.cloned.querySelectorAll('source'));
			let theDuration = 0;
			
			let newAudio = new Audio();
			newAudio.id = "new_audio";
			newAudio.controls = true;
			newAudio.autoplay = false;
			newAudio.setAttribute('x-webkit-airplay', true);

			let newSourceMpeg = document.createElement('source');
			newSourceMpeg.src = window.location.protocol + "//" + window.location.host + source[0].getAttribute('src');
			newSourceMpeg.type = "audio/mpeg";
			newAudio.appendChild(newSourceMpeg);

			let newSourceWav = document.createElement('source');
			newSourceWav.src = window.location.protocol + "//" + window.location.host + source[0].getAttribute('src');
			newSourceWav.type = "audio/wav";
			newAudio.appendChild(newSourceWav);
			
			this.audio = newAudio;

			this.audio.addEventListener('loadedmetadata', ()=>{
				theDuration = Math.ceil(this.audio.duration);
				let minutes: any = "0" + Math.floor(theDuration / 60);
				let seconds: any = "0" + (theDuration - minutes * 60);
				this.duration.map((item)=>{
					item.innerHTML = minutes.substr(-2) + ":" + seconds.substr(-2);
				})
				this.progress.setAttribute('max', theDuration);
			})

			this.audio.addEventListener('timeupdate', ()=>{
				let curTime = this.audio.currentTime;
				this.progress.value = curTime;
				this.progressDiv.style.width =  100 / this.audio.duration * curTime + "%";
				let formattedTime = parseInt(this.audio.currentTime, 10);
				let minutes: any = "0" + Math.floor(formattedTime / 60);
				let seconds: any = "0" + (formattedTime - minutes * 60);

				this.current.map((item)=>{
					item.innerHTML = minutes.substr(-2) + ":" + seconds.substr(-2);
				})
			})

			this.audio.addEventListener('ended', ()=>{
				this.progress.value = 0;
				this.current.innerHTML = "00:00";
				this.button.classList.remove('playing');
				this.progressDiv.style.width =  "0%";
			})

		}

	}

	changeProgress(event: any = '') {
		if(event) {
			this.audio.pause();
			this.button.classList.remove('playing');
			let element;
			element = event.target;
			this.audio.currentTime = element.value;
			this.progressDiv.style.width =  100 / this.audio.duration * this.audio.currentTime + "%";
		}
	}

	changeVolume(event: any = '') {
		if(event) {
			let element;
			element = event.target;
			this.audio.volume = element.value;
			this.valueStoredVolume = element.value;
			this.volumeDiv.style.width = this.valueStoredVolume * 100 + "%";
			this.volumeDivThumb.style.left = this.valueStoredVolume * 100 + "%";
			if(this.valueStoredVolume == 0) {
				this.volumeButton.classList.add('muted');
			}else{
				this.volumeButton.classList.remove	('muted');
			}
		}
	}

	muteClick(event: any = '') {
		if(event) {
			let element;
			if(event.currentTarget) {
				element = event.currentTarget;
			}else{
				element = event.target
			}
			if(element.classList.contains('muted')){
				element.classList.remove('muted');
				if(this.valueStoredVolume == 0){
					this.audio.volume = 0.5;
					this.volume.value = 0.5;
					this.valueStoredVolume = 0.5;
					this.volumeDiv.style.width = 0.5 * 100 + "%";
					this.volumeDivThumb.style.left = 0.5 * 100 + "%";
				}else{
					this.audio.volume = this.valueStoredVolume;
					this.volume.value = this.valueStoredVolume;
					this.volumeDiv.style.width = this.valueStoredVolume * 100 + "%";
					this.volumeDivThumb.style.left = this.valueStoredVolume * 100 + "%";
				}
			}else{
				element.classList.add('muted');
				this.audio.volume = 0.0;
				this.volume.value = 0.0;
				this.volumeDiv.style.width = 0 + "%";
				this.volumeDivThumb.style.left = 0 + "%";
			}
		}
	}

}


// WEBPACK FOOTER //
// ./components/podcast/podcast.component.ts